/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type CheckLoginQueryVariables = Exact<{
  login: string;
}>;

export type CheckLoginQuery = {
  loginExists: {
    availableAccounts: Array<Types.UserType | null> | null;
    status: boolean | null;
  } | null;
};

export type CheckPasswordQueryVariables = Exact<{
  login: string;
  password: string;
  deviceId: string;
  deviceName: string;
}>;

export type CheckPasswordQuery = {
  checkPassword: {
    has2fa: boolean | null;
    twoFactorMethod: Types.TwoFactorMethod | null;
    twoFactorChallengeId: string | null;
    status: boolean | null;
    token: string | null;
    firstName: string | null;
  } | null;
};

export type AutoLoginQueryVariables = Exact<{
  token?: string | null | undefined;
}>;

export type AutoLoginQuery = {
  autoLogin: { firstName: string | null; token: string | null } | null;
};

export type CheckAuthCodeQueryVariables = Exact<{
  code: string;
  rememberMe: boolean;
  deviceId: string;
  twoFactorChallengeId?: string | null | undefined;
}>;

export type CheckAuthCodeQuery = {
  checkAuthCode: { status: boolean | null; token: string | null } | null;
};

export type SendPasswordResetEmailMutationVariables = Exact<{
  login: string;
}>;

export type SendPasswordResetEmailMutation = {
  sendPasswordResetEmail: { status: boolean | null } | null;
};

export type CheckPasswordResetCodeQueryVariables = Exact<{
  code: string;
  login: string;
}>;

export type CheckPasswordResetCodeQuery = {
  checkPasswordResetCode: { status: boolean | null } | null;
};

export type ResetPasswordMutationVariables = Exact<{
  code: string;
  login: string;
  password: string;
  deviceId: string;
  deviceName: string;
}>;

export type ResetPasswordMutation = {
  resetPassword: {
    status: boolean | null;
    firstName: string | null;
    has2fa: boolean | null;
    twoFactorMethod: Types.TwoFactorMethod | null;
    twoFactorChallengeId: string | null;
    token: string | null;
  } | null;
};

export type LogoutCurrentUserMutationVariables = Exact<{
  [key: string]: never;
}>;

export type LogoutCurrentUserMutation = {
  logoutCurrentUser: { status: boolean | null } | null;
};

export type StartPhotographerRegistrationMutationVariables = Exact<{
  input: Types.RegisterPhotographerInput;
}>;

export type StartPhotographerRegistrationMutation = {
  startPhotographerRegistration: {
    status: boolean;
    smsSent: boolean;
    errorCode: Types.RegisterPhotographerInitErrorCode | null;
  } | null;
};

export type FinalizePhotographerRegistrationMutationVariables = Exact<{
  phone: string;
  code: string;
  deviceId: string;
  deviceName: string;
}>;

export type FinalizePhotographerRegistrationMutation = {
  finalizePhotographerRegistration: {
    status: boolean;
    token: string | null;
    firstName: string | null;
  } | null;
};

export const CheckLoginDocument = gql`
  query checkLogin($login: String!) {
    loginExists(login: $login) {
      availableAccounts
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CheckLoginGQL extends Apollo.Query<
  CheckLoginQuery,
  CheckLoginQueryVariables
> {
  document = CheckLoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CheckPasswordDocument = gql`
  query checkPassword(
    $login: String!
    $password: String!
    $deviceId: ID!
    $deviceName: String!
  ) {
    checkPassword(
      login: $login
      password: $password
      deviceId: $deviceId
      deviceName: $deviceName
    ) {
      has2fa
      twoFactorMethod
      twoFactorChallengeId
      status
      token
      firstName
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CheckPasswordGQL extends Apollo.Query<
  CheckPasswordQuery,
  CheckPasswordQueryVariables
> {
  document = CheckPasswordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AutoLoginDocument = gql`
  query autoLogin($token: ID) {
    autoLogin(token: $token) {
      firstName
      token
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AutoLoginGQL extends Apollo.Query<
  AutoLoginQuery,
  AutoLoginQueryVariables
> {
  document = AutoLoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CheckAuthCodeDocument = gql`
  query checkAuthCode(
    $code: String!
    $rememberMe: Boolean!
    $deviceId: ID!
    $twoFactorChallengeId: ID
  ) {
    checkAuthCode(
      code: $code
      trustThisDevice: $rememberMe
      deviceId: $deviceId
      twoFactorChallengeId: $twoFactorChallengeId
    ) {
      status
      token
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CheckAuthCodeGQL extends Apollo.Query<
  CheckAuthCodeQuery,
  CheckAuthCodeQueryVariables
> {
  document = CheckAuthCodeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SendPasswordResetEmailDocument = gql`
  mutation sendPasswordResetEmail($login: String!) {
    sendPasswordResetEmail(email: $login) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SendPasswordResetEmailGQL extends Apollo.Mutation<
  SendPasswordResetEmailMutation,
  SendPasswordResetEmailMutationVariables
> {
  document = SendPasswordResetEmailDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CheckPasswordResetCodeDocument = gql`
  query checkPasswordResetCode($code: String!, $login: String!) {
    checkPasswordResetCode(code: $code, email: $login) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CheckPasswordResetCodeGQL extends Apollo.Query<
  CheckPasswordResetCodeQuery,
  CheckPasswordResetCodeQueryVariables
> {
  document = CheckPasswordResetCodeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ResetPasswordDocument = gql`
  mutation resetPassword(
    $code: String!
    $login: String!
    $password: String!
    $deviceId: ID!
    $deviceName: String!
  ) {
    resetPassword(
      code: $code
      email: $login
      newPassword: $password
      deviceId: $deviceId
      deviceName: $deviceName
    ) {
      status
      firstName
      has2fa
      twoFactorMethod
      twoFactorChallengeId
      token
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordGQL extends Apollo.Mutation<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
> {
  document = ResetPasswordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LogoutCurrentUserDocument = gql`
  mutation logoutCurrentUser {
    logoutCurrentUser {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LogoutCurrentUserGQL extends Apollo.Mutation<
  LogoutCurrentUserMutation,
  LogoutCurrentUserMutationVariables
> {
  document = LogoutCurrentUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const StartPhotographerRegistrationDocument = gql`
  mutation startPhotographerRegistration($input: RegisterPhotographerInput!) {
    startPhotographerRegistration(input: $input) {
      status
      smsSent
      errorCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class StartPhotographerRegistrationGQL extends Apollo.Mutation<
  StartPhotographerRegistrationMutation,
  StartPhotographerRegistrationMutationVariables
> {
  document = StartPhotographerRegistrationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FinalizePhotographerRegistrationDocument = gql`
  mutation finalizePhotographerRegistration(
    $phone: String!
    $code: String!
    $deviceId: ID!
    $deviceName: String!
  ) {
    finalizePhotographerRegistration(
      phone: $phone
      code: $code
      deviceId: $deviceId
      deviceName: $deviceName
    ) {
      status
      token
      firstName
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FinalizePhotographerRegistrationGQL extends Apollo.Mutation<
  FinalizePhotographerRegistrationMutation,
  FinalizePhotographerRegistrationMutationVariables
> {
  document = FinalizePhotographerRegistrationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
